const getShippingMethodsToStoreInState = charges => {
  const shippingMethods = charges.map(({ id: cachedId, shipping, tax }) => {
    const {
      id,
      type,
      hasInsurance,
      insuranceAmount,
      isDefaultShippingOption,
      label,
      shippingAmount,
      deliveryTime,
      shippingMethodType,
    } = shipping || {};

    // taxItemAmount is used when no_shipping is set.  taxAmount may include the tax
    // on the shipping costs, but the taxItemAmount will not have that
    const { item: taxItemAmount, total: taxAmount } = tax || {};

    return {
      amount: shippingAmount,
      cachedId,
      default: isDefaultShippingOption,
      deliveryTime,
      hasInsurance,
      id,
      insuranceAmount,
      label,
      selected: isDefaultShippingOption,
      shippingMethodType,
      taxAmount,
      taxItemAmount,
      type,
    };
  });

  if (shippingMethods.find(method => method.default)) {
    return shippingMethods;
  }

  // Select the cheapest option as default if no default was provided by
  // the merchant
  const shippingMethodsWithDefault =
    selectDefaultShippingMethod(shippingMethods);

  return shippingMethodsWithDefault;
};

const selectDefaultShippingMethod = shippingMethods => {
  shippingMethods.sort(
    (a, b) => a.amount.currencyValue - b.amount.currencyValue,
  );
  shippingMethods[0].selected = true;
  return shippingMethods;
};

export { getShippingMethodsToStoreInState };
